import { PackageSetEntryFragment } from '@graphql/platform';

export const amountForFinalPackageSetEntry = ({
  finalPackageSetEntry,
  onboardingPackageSetEntry,
}: {
  finalPackageSetEntry?: PackageSetEntryFragment;
  onboardingPackageSetEntry?: PackageSetEntryFragment;
}): number => {
  const amount = finalPackageSetEntry?.amount;
  if (amount) {
    if (finalPackageSetEntry?.cappedAtOnboardingAmount) {
      return Math.min(amount, onboardingPackageSetEntry?.amount ?? 0);
    } else {
      return amount;
    }
  }
  return 0;
};
